import ConfigurationHubPlaceholder from '../../../sections/AdminDashboard/Configuration/ConfigurationHubPlaceholder';

const Verifications = () => <ConfigurationHubPlaceholder title="Verifications" />;

export default Verifications;
